import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage, useIntl } from 'react-intl'
import { navigateToInApp } from '../../utils/URLSchemeHelper'
import moment from 'moment'

const TrainPositionsFooter = ({ lineName, updatedAt, themeName, appVersion }) => {
  const intl = useIntl()
  const locale = intl.locale

  // updatedAt はtrains.json中に、tid-converterでTime.current.to_iで生成しているが、Javascriptで扱うため、ミリ秒に変換するため、* 1000にする。
  const updatedAtStr = () => moment.tz(updatedAt * 1000, 'Asia/Tokyo').format("H:mm:ss")

  const routeMapLineName = (lineName === 'for_jre') ? 'for_tokyu': lineName
    
  const handleClickRouteMap = (event) => {
    navigateToInApp(event, `/lines/${routeMapLineName}/route_map`, appVersion, '&close=false')
  }

  return (
    <footer className={`c-Footer is_${locale}`}>
      <div className="c-Footer-inner">
        <Link to={`/lines/${routeMapLineName}/route_map`} className={`c-Footer-button c-Footer-button-routemap-${themeName}`} onClick={handleClickRouteMap}></Link>
        <Link to={`/trains/kinds`} className={`c-Footer-button c-Footer-button-hanrei-${themeName}`}></Link>
      </div>
      <div className="c-Footer-note">
        <p>
          <FormattedMessage id='App.TrainPositions.footer.actualMayDiffer' />
        </p>
        {updatedAt > 0 && (
          <p><FormattedMessage id='App.TrainPositions.footer.displayTime' />{updatedAtStr()}</p>
        )}
      </div>
    </footer>
  )
}

TrainPositionsFooter.propTypes = {
  lineName: PropTypes.string.isRequired,
  updatedAt: PropTypes.number,
  themeName: PropTypes.string.isRequired,
  appVersion: PropTypes.string,
}

export default TrainPositionsFooter
